/**
 * @generated SignedSource<<20a95c1c17ae0394c4395b1de43a3d77>>
 * @relayHash b58549eb38b3e361a68d498836b54461
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d5eca122ddd243d427b707c4f9357bfbc8dad92c307167919353b47f5297e462

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ReverseTrialCohort = "CONTROL" | "ENROLLED" | "NOT_ENROLLED" | "UNASSIGNED" | "UNKNOWN" | "VARIANT" | "%future added value";
export type confluencePremiumPopupEditionAwarenessQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
  isConfluence: boolean;
};
export type confluencePremiumPopupEditionAwarenessQuery$data = {
  readonly signUpProperties?: {
    readonly reverseTrial: ReverseTrialCohort | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type confluencePremiumPopupEditionAwarenessQuery = {
  response: confluencePremiumPopupEditionAwarenessQuery$data;
  variables: confluencePremiumPopupEditionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hamsProductKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConfluence"
},
v3 = {
  "condition": "isConfluence",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "SignUpProperties",
      "kind": "LinkedField",
      "name": "signUpProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "reverseTrial"
        }
      ]
    }
  ]
},
v4 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v7 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "confluencePremiumPopupEditionAwarenessQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": (v4/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "confluencePremiumPopupEditionAwarenessQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": (v4/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d5eca122ddd243d427b707c4f9357bfbc8dad92c307167919353b47f5297e462",
    "metadata": {},
    "name": "confluencePremiumPopupEditionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "52a91e42dd5619a8e9bdb354cc3cc606";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
